import { Component, OnInit } from '@angular/core';

import { PegaNextAction } from '@ap/pega';

import { SamenRekeningOpenenDirective } from '../samen-rekening-openen/samen-rekening-openen.directive';
import { DistributionChannelType } from '../samen-rekening-openen/samen-rekening-openen.model';

@Component({
    selector: 'retail-samen-rekening-openen',
    templateUrl: './retail-samen-rekening-openen.component.html',
    standalone: false
})
export class RetailSamenRekeningOpenenComponent extends SamenRekeningOpenenDirective implements OnInit {
    public ngOnInit(): void {
        super.ngOnInit();
        this.content.DistributionChannelType = DistributionChannelType.RETAIL;
    }

    public handleNextAction(event: { action: PegaNextAction; payload?: any }): void {
        switch (event.action) {
            case PegaNextAction.Exit:
                this.windowService.location_href('/');
                break;
            case PegaNextAction.LogOff: {
                const redirectUrl = event.payload;
                this.logout(redirectUrl);
                break;
            }
        }
    }
}
